import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import {
  Loading,
  InputCustom,
  InputMaskCustom,
  SelectCustom,
  HttpError
} from "../../components"
import { UnidadesModal, LoadModalWithLabel } from "../modais"
import * as constants from "../../constants"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import { ToastContainer, ToastMessage } from "react-toastr"
class FiscaisForm extends Component {
  constructor() {
    super()
    this.getInitialFieldsEdit = this.getInitialFieldsEdit.bind(this)
    this.reloadUnidades = this.reloadUnidades.bind(this)
    this.toggleUnidadesModal = this.toggleUnidadesModal.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.onChangeNome = this.onChangeNome.bind(this)
    this.onChangeEmail = this.onChangeEmail.bind(this)
    this.onChangePortariaExoneracao = this.onChangePortariaExoneracao.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.onChangeMatricula = this.onChangeMatricula.bind(this)
    this.onChangeBloqueado = this.onChangeBloqueado.bind(this)
    this.onChangePortaria = this.onChangePortaria.bind(this)
    this.onChangeCPF = this.onChangeCPF.bind(this)
    this.onChangeVinculo = this.onChangeVinculo.bind(this)
    this.onChangeUnidade = this.onChangeUnidade.bind(this)
    this.onChangeTelefone1 = this.onChangeTelefone1.bind(this)
    this.onChangeTelefone2 = this.onChangeTelefone2.bind(this)
    this.onKeyDownTelefone1 = this.onKeyDownTelefone1.bind(this)
    this.onKeyDownTelefone2 = this.onKeyDownTelefone2.bind(this)
    this.onChangeNomeDeUsuario = this.onChangeNomeDeUsuario.bind(this)
    this.onChangeSenha = this.onChangeSenha.bind(this)
    this.onChangeConfirmacaoSenha = this.onChangeConfirmacaoSenha.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showModal: false,
      nome: "",
      email: "",
      portaria: "",
      portariaExoneracao: "",
      matricula: "",
      showPortariaExoneracao: false,
      showForm: false,
      bloqueado: false,
      vinculos: [],
      unidades: [],
      vinculo: "",
      unidade: "",
      cpf: "",
      telefone1: "",
      telefone2: "",
      maskTelefone1: "(99) 9999-9999",
      maskTelefone2: "(99) 9999-9999",
      nomeDeUsuario: "",
      confirmacaoSenha: "",
      senha: ""
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  shouldSelectUnidadeOrcamentaria() {
    return (
      constants.haveRole(1) ||
      constants.getUserUniOrc().length > 1
    )
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message = "Fiscal atualizado com sucesso"
    } else {
      message = "Fiscal cadastrado com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    ApiHelper.getMe(error => {
      if (!error) {
        if (this.props.isEditing) {
          this.getInitialFieldsEdit()
        } else {
          this.getInitialFields()
        }
      }
    })
  }
  getInitialFieldsEdit() {
    ApiHelper.getEditFieldsFiscal(
      this.props.match.params.id,
      (fields, error) => {
        if (fields) {
          this.fillFields(fields.fiscal)
          this.setState(
            {
              showForm: true,
              vinculos: fields.vinculos,
              unidades: fields.unidades
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      }
    )
  }
  getInitialFields() {
    ApiHelper.getCreateFieldsFiscal((fields, error) => {
      if (fields) {
        this.setState(
          {
            showForm: true,
            vinculos: fields.vinculos,
            unidades: fields.unidades
          },
          () => {
            window.scrollTo(0, 0)
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    var shouldShowPortariaExoneracao = fields.vinculo_id === 4
    var currentFields = {
      nomeDeUsuario: fields.username,
      nome: fields.name,
      nomeLabel: fields.name,
      senha: undefined,
      confirmacaoSenha: undefined,
      cpf: fields.cpf,
      email: fields.email,
      vinculo: fields.vinculo_id,
      portaria: fields.portaria,
      unidade: fields.unidade_orcamentaria[0].id,
      matricula: fields.matricula,
      bloqueado: fields.bloqueado === 0 ? false : true,
      telefone1: fields.telefone1,
      telefone2: fields.telefone2 || undefined,
      portariaExoneracao: fields.portaria_exoneracao || "",
      showPortariaExoneracao: shouldShowPortariaExoneracao,
      showForm: true
    }
    this.setState(currentFields)
  }
  onChangeNome(event) {
    this.setState({ nomeError: "" })
    var newValue = event.target.value
    this.setState({ nome: newValue })
  }
  onChangeEmail(event) {
    this.setState({ emailError: "" })
    var newValue = event.target.value.toLowerCase()
    this.setState({ email: newValue })
  }
  onChangePortariaExoneracao(event) {
    this.setState({ portaria_exoneracaoError: "" })
    var newValue = event.target.value
    this.setState({ portariaExoneracao: newValue })
  }
  onChangeMatricula(event) {
    this.setState({ matriculaError: "" })
    var newValue = event.target.value
    this.setState({ matricula: newValue })
  }
  onChangeBloqueado(event) {
    this.setState({ bloqueadoError: "" })
    var newValue = event.target.value
    this.setState({ bloqueado: newValue })
  }
  onChangePortaria(event) {
    this.setState({ portariaError: "" })
    var newValue = event.target.value
    this.setState({ portaria: newValue })
  }
  onChangeVinculo(event) {
    this.setState({ vinculo_idError: "" })
    var newValue = event.target.value
    //Exonerado
    if (newValue === 4) {
      //Mostra a portaria de exoneração
      this.setState({ showPortariaExoneracao: true })
    } else {
      //Não exonerado
      //Esconde de novo o campo
      this.setState({ showPortariaExoneracao: false })
    }
    this.setState({ vinculo: newValue })
  }
  onChangeUnidade(event) {
    this.setState({ unidade_orcamentaria_idError: "" })
    var newValue = event.target.value
    this.setState({ unidade: newValue })
  }
  //Mascara de telefone
  onChangeTelefone1(event) {
    this.setState({ telefone1Error: "" })
    var newValue = event.target.value
    this.setState({ telefone1: newValue })
  }

  onKeyDownTelefone1(event) {
    var keyPressed = event.key
    var unmaskedField = Util.unmaskField(this.state.telefone1)
    if (unmaskedField.length === 10 && !isNaN(keyPressed)) {
      this.setState({
        telefone1: this.state.telefone1 + keyPressed,
        maskTelefone1: "(99) 99999-9999"
      })
    } else if (unmaskedField.length === 11 && event.keyCode === 8) {
      this.setState({ maskTelefone1: "(99) 9999-9999" })
    }
  }
  onChangeTelefone2(event) {
    this.setState({ telefone2Error: "" })
    var newValue = event.target.value
    this.setState({ telefone2: newValue })
  }

  onKeyDownTelefone2(event) {
    var keyPressed = event.key
    var unmaskedField = Util.unmaskField(this.state.telefone2)
    if (unmaskedField.length === 10 && !isNaN(keyPressed)) {
      this.setState({
        telefone2: this.state.telefone2 + keyPressed,
        maskTelefone2: "(99) 99999-9999"
      })
    } else if (unmaskedField.length === 11 && event.keyCode === 8) {
      this.setState({ maskTelefone2: "(99) 9999-9999" })
    }
  }
  onChangeNomeDeUsuario(event) {
    var newValue = event.target.value
    this.setState({ nomeDeUsuario: newValue, usernameError: "" })
  }
  onChangeSenha(event) {
    var newValue = event.target.value
    this.setState({ senha: newValue, passwordError: "" })
  }
  onChangeConfirmacaoSenha(event) {
    var newValue = event.target.value
    this.setState({
      confirmacaoSenha: newValue,
      password_confirmationError: ""
    })
  }
  //Mascara de telefone
  unmaskField(value) {
    var unsmaked = value.split("(").join("")
    unsmaked = unsmaked.split(")").join("")
    unsmaked = unsmaked.split(" ").join("")
    unsmaked = unsmaked.split("-").join("")
    unsmaked = unsmaked.split("/").join("")
    unsmaked = unsmaked.split(".").join("")
    return unsmaked
  }

  mapVinculos(vinculos) {
    var mappedVinculos = [{ value: null, label: "" }]
    vinculos.forEach(value => {
      mappedVinculos.push({ value: value.id, label: value.nome })
    })
    return mappedVinculos
  }
  sendForm(event) {
    event.preventDefault()
    var parameters = {
      name: this.state.nome,
      password: this.state.senha,
      password_confirmation: this.state.confirmacaoSenha,
      username: this.state.nomeDeUsuario,
      cpf: Util.unmaskField(this.state.cpf),
      portaria: this.state.portaria,
      matricula: this.state.matricula,
      portaria_exoneracao: this.state.portariaExoneracao,
      email: this.state.email,
      telefone1: Util.unmaskField(this.state.telefone1),
      telefone2: this.state.telefone2
        ? Util.unmaskField(this.state.telefone2)
        : "",
      unidade_orcamentaria_id: this.shouldSelectUnidadeOrcamentaria()
        ? this.state.unidade
        : constants.getUserUniOrc()[0],
      vinculo_id: this.state.vinculo,
      bloqueado:
        this.state.bloqueado === "false" || this.state.bloqueado === false
          ? 0
          : 1
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateFiscal(parameters, this.props.match.params.id, errors => {
        this.toggleLoadModal()
        if (errors) {
          this.showErrorMessage()
          this.handleErrors(errors)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackFiscais()
          })
        }
      })
    } else {
      ApiHelper.createNewFiscal(parameters, errors => {
        this.toggleLoadModal()
        if (errors) {
          this.showErrorMessage()
          this.handleErrors(errors)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackFiscais()
          })
        }
      })
    }
  }
  onChangeCPF(event) {
    this.setState({ cpfError: "" })
    var newValue = event.target.value
    this.setState({ cpf: newValue })
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.errors
    var errorsState = {}
    for (var key in errorsValue) {
      errorsState[key + "Error"] = errorsValue[key][0]
    }
    this.setState(errorsState)
  }
  toggleUnidadesModal() {
    this.setState({ showModal: !this.state.showModal })
  }
  reloadUnidades(unidades) {
    var newUnidades = Util.mapUnidades(unidades)
    this.setState({ showModal: false, unidades: newUnidades })
  }
  render() {
    var bloqueados = [
      { value: true, label: "Sim" },
      { value: false, label: "Não" }
    ]
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <div>
          <div className="card card-plain">
            <ToastContainer
              ref={input => {
                this.container = input
              }}
              toastMessageFactory={this.toastFactory}
              className="toast-top-right"
              preventDuplicates={true}
            />
            <div className="card-header" data-background-color="as-blue">
              <h4 className="title">
                {this.props.isEditing ? "Editar fiscal" : "Criar fiscal"}
              </h4>
              <p className="category">
                {this.props.isEditing
                  ? "Fiscal:  " + (this.state.nomeLabel || "")
                  : "Criar novo fiscal de contrato"}
              </p>
            </div>
            <div className="card-content">
              <UnidadesModal
                callBack={this.reloadUnidades}
                show={this.state.showModal}
                onClose={this.toggleUnidadesModal}
              />
              <form>
                {this.state.showForm === false ? (
                  <div className="row">
                    <Loading />
                  </div>
                ) : (
                  <div>
                    <div className="row">
                      <InputCustom
                        error={this.state.usernameError}
                        sizeClass="col-md-5"
                        label={"Nome de usuário (Usado para acessar o sistema)"}
                        type="text"
                        onChange={this.onChangeNomeDeUsuario}
                        value={this.state.nomeDeUsuario}
                      />
                    </div>
                    <div className="row">
                      <InputMaskCustom
                        mask="999.999.999-99"
                        error={this.state.cpfError}
                        sizeClass="col-md-2"
                        label="CPF"
                        type="text"
                        onChange={this.onChangeCPF}
                        value={this.state.cpf}
                      />
                      <InputCustom
                        error={this.state.nomeError}
                        sizeClass="col-md-4"
                        label={"Nome do fiscal"}
                        type="text"
                        onChange={this.onChangeNome}
                        value={this.state.nome}
                      />
                      <InputCustom
                        error={this.state.portariaError}
                        sizeClass="col-md-2"
                        label={"Portaria"}
                        type="text"
                        onChange={this.onChangePortaria}
                        value={this.state.portaria}
                      />
                      <InputCustom
                        error={this.state.matriculaError}
                        sizeClass="col-md-2"
                        label={"Matrícula"}
                        type="number"
                        onChange={this.onChangeMatricula}
                        value={this.state.matricula}
                      />
                      <SelectCustom
                        error={this.state.vinculo_idError}
                        sizeClass="col-md-2"
                        options={this.state.vinculos}
                        label={"Vínculo"}
                        name={"vinculos"}
                        onChange={this.onChangeVinculo}
                        value={this.state.vinculo}
                      />
                    </div>
                    <div>
                      {this.state.showPortariaExoneracao === true && (
                        <div className="row">
                          <InputCustom
                            error={this.state.portaria_exoneracaoError}
                            sizeClass="col-md-2"
                            label={"Portaria de exoneração"}
                            type="text"
                            onChange={this.onChangePortariaExoneracao}
                            value={this.state.portariaExoneracao}
                          />
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <InputCustom
                        error={this.state.emailError}
                        sizeClass="col-md-5"
                        label="Email"
                        type="text"
                        onChange={this.onChangeEmail}
                        value={this.state.email}
                      />
                      <InputMaskCustom
                        error={this.state.telefone1Error}
                        onKeyDown={this.onKeyDownTelefone1}
                        mask={this.state.maskTelefone1}
                        sizeClass="col-md-2"
                        label="Telefone"
                        type="text"
                        onChange={this.onChangeTelefone1}
                        value={this.state.telefone1}
                      />
                      <InputMaskCustom
                        error={this.state.telefone2Error}
                        onKeyDown={this.onKeyDownTelefone2}
                        mask={this.state.maskTelefone2}
                        sizeClass="col-md-2"
                        label={"Telefone (Opcional)"}
                        type="text"
                        onChange={this.onChangeTelefone2}
                        value={this.state.telefone2}
                      />
                      <SelectCustom
                        error={this.state.bloqueadoError}
                        sizeClass="col-md-1"
                        options={bloqueados}
                        label={"Bloqueado"}
                        name={"bloqueado"}
                        onChange={this.onChangeBloqueado}
                        value={this.state.bloqueado}
                      />
                    </div>
                    <div className="row">
                      <InputCustom
                        error={this.state.passwordError}
                        sizeClass="col-md-4"
                        label={this.props.isEditing ? "Nova senha" : "Senha"}
                        type={"password"}
                        onChange={this.onChangeSenha}
                        value={this.state.senha}
                      />
                      <InputCustom
                        error={this.state.password_confirmationError}
                        sizeClass="col-md-4"
                        label={
                          this.props.isEditing
                            ? "Confirme a nova senha"
                            : "Confirme a senha"
                        }
                        type={"password"}
                        onChange={this.onChangeConfirmacaoSenha}
                        value={this.state.confirmacaoSenha}
                      />
                    </div>
                    {this.shouldSelectUnidadeOrcamentaria() && (
                      <div className="row">
                        <SelectCustom
                          error={this.state.unidade_orcamentaria_idError}
                          sizeClass="col-md-3"
                          options={this.state.unidades}
                          label="Unidade orçamentária"
                          name={"unidades"}
                          onChange={this.onChangeUnidade}
                          value={this.state.unidade}
                        />
                          {constants.haveRole(1)&& (
                          <div>
                            <br />
                            <button
                              onClick={this.toggleUnidadesModal}
                              style={{ width: "4%" }}
                              type="button"
                              rel="tooltip"
                              title="Criar contratado"
                              className="btn btn-success btn-simple btn-xs col-md-1"
                            >
                              <i
                                className="icon-header material-icons"
                                style={{ fontSize: 20 }}
                              >
                                control_point
                              </i>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    <button
                      onClick={this.sendForm}
                      type="submit"
                      className="btn btn-primary pull-right"
                      data-background-color="as-blue"
                    >
                      {this.props.isEditing ? "Salvar" : "Criar"}
                    </button>
                    <div className="clearfix" />
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default withRouter(FiscaisForm)



// WEBPACK FOOTER //
// ./src/views/modais/FiscaisForm.js